import { render, staticRenderFns } from "./index-landing-four.vue?vue&type=template&id=e80a9100&"
import script from "./index-landing-four.vue?vue&type=script&lang=js&"
export * from "./index-landing-four.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports